import { Route, Routes, useNavigate } from "react-router-dom";

import { Guid } from "@/Common/Models/Guid";
import { PharmacyOrdersInbox } from "./PharmacyOrdersInbox";
import { PharmacyOrdersView } from "./PharmacyOrdersView";

import styles from "./PharmacyOrdersTab.module.scss";

function PharmacyOrdersTab(): JSX.Element {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <Routes>
                <Route
                    path=""
                    element={(
                        <PharmacyOrdersInbox
                            onRowClickCallback={(orderId: Guid) => navigate(`/orders/${orderId}`)}
                        />
                    )}
                />
                <Route
                    path=":orderId"
                    element={(<PharmacyOrdersView />)}
                />
            </Routes>
        </div>
    );
}

export { PharmacyOrdersTab };
